module.exports = __webpack_public_path__ + "media/images/steps/png/233-curriculum-1-2d5f8ac3dc0cefa9ac4a877d56b653a0.png";